// client/src/components/ResultsList.js
// <!-- by Majed Developer Solution © 2025 -->

import React from 'react';

export default function ResultsList({ results, onSelect }) {

  if (!results || results.length === 0) {
    return (
      <p
        style={{
          textAlign: "center",
          padding: "20px",
          opacity: 0.7
        }}
      >
        No results / لا توجد نتائج
      </p>
    );
  }

  return (
    <div style={{ paddingBottom: "30px" }}>
      {results.map(place => (
        <div
          key={place.place_id}
          onClick={() => onSelect(place.place_id)}
          style={{
            background: "#ffffff",
            marginBottom: "12px",
            padding: "14px 18px",
            borderRadius: "16px",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
            transition: "0.2s",
            borderLeft: "6px solid #25d366"
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = "scale(1.02)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = "scale(1.0)";
          }}
        >
          {/* NAME */}
          <div style={{ fontSize: "1.05rem", fontWeight: "bold" }}>
            {place.name}
          </div>

          {/* RATING */}
          {place.rating !== null && (
            <div
              style={{
                color: "#f1c40f",
                fontSize: "0.9rem",
                fontWeight: "bold",
                marginTop: "4px"
              }}
            >
              ⭐ {place.rating}
            </div>
          )}

          {/* ADDRESS */}
          <div
            style={{
              marginTop: "6px",
              opacity: 0.8,
              fontSize: "0.9rem"
            }}
          >
            {place.formatted_address}
          </div>
        </div>
      ))}
    </div>
  );
}
